import React, { ReactNode } from "react";

import { Form } from "react-bootstrap";

interface FormHelperTextProps {
  children: ReactNode;
}

export const FormHelperText = ({ children }: FormHelperTextProps) => (
  <Form.Text className="text-muted">{children}</Form.Text>
);
